import {FlashSaleProduct, FlashSaleProductData} from '@/__generated__/__types__';
import {ProductLabelType} from '@/_application/modules/products/components/labels/product-label';

export const getRemainingQuantity = (flashSaleData: FlashSaleProductData | null | undefined) => {
    const saleQty = flashSaleData?.sale_qty ?? 0;
    const dealQty = flashSaleData?.deal_qty ?? 0;

    return dealQty - saleQty;
};

export const isFlashSaleInStock = (flashSaleData: FlashSaleProduct['sales_data'] | null | undefined) => {
    const saleQuantity = flashSaleData?.sale_qty ?? 0;
    const dealQuantity = flashSaleData?.deal_qty ?? 0;

    return saleQuantity < dealQuantity;
};

export const getHiddenLabelsInFlashSale = (
    flashSaleData: FlashSaleProductData | null | undefined,
): ProductLabelType[] => {
    if (!flashSaleData) return [];

    return isFlashSaleInStock(flashSaleData) ? ['gift'] : ['sale'];
};
